// src/pages/help/topics/agentIaMt5.js
// Guide « Agent IA MT5 ». Contenu validé — toute modification se fait ici.
export const fr = {
  title: "Agent IA MT5",
  tagline: "Relier ton compte MetaTrader 5 à FullMetrix",
  readMin: 8,
  intro:
    "L'Agent IA MT5 est un programme à installer sur MetaTrader 5. Il relie ton compte de trading à FullMetrix pour synchroniser automatiquement tes données, alimenter ton journal de trading, analyser tes performances, gérer certaines positions depuis FullMetrix et utiliser les outils compatibles avec ton compte MT5.",
  brief: [
    "Autoriser le trading algorithmique et les WebRequest dans MetaTrader 5",
    "Installer l'Agent sur un graphique MT5",
    "Générer un token FullMetrix et le renseigner dans l'Agent",
  ],
  steps: [
    {
      title: "Autoriser la connexion dans MetaTrader 5",
      text: "Outils → Options (ou Paramètres) → Expert Advisors : active le trading algorithmique, active les WebRequest pour les URL listées, ajoute l'adresse https://ia.fullmargin.net puis valide.",
    },
    {
      title: "Télécharger l'Agent",
      text: "Depuis la section Agent IA de FullMetrix.",
    },
    {
      title: "Copier le fichier dans MT5",
      text: "MetaTrader 5 → Fichier → Ouvrir le dossier des données → dossier MQL5, puis place le fichier de l'Agent dans le dossier indiqué par le guide d'installation.",
    },
    {
      title: "Redémarrer MetaTrader 5",
      text: "Redémarre MT5 ou actualise le navigateur pour qu'il détecte l'Agent.",
    },
    {
      title: "Ajouter l'Agent sur un graphique",
      text: "Ouvre un graphique, ajoute l'Agent dessus, et vérifie que le trading algorithmique est bien activé.",
    },
    {
      title: "Générer un token et le coller",
      text: "Dans la section Agent IA de FullMetrix : génère un token, donne-lui un nom reconnaissable, copie-le, puis colle-le dans les paramètres de l'Agent sur MT5 et valide.",
    },
  ],
  tips: [
    "Un token différent par compte MT5 : c'est ce qui garde les statistiques séparées et lisibles.",
    "Nomme tes tokens (Compte principal, Compte prop firm, Compte Forex, Compte Indices, Compte Démo) pour t'y retrouver.",
    "MetaTrader 5 doit rester ouvert et connecté : sans terminal actif, pas de synchro temps réel.",
    "Un VPS permet de garder MT5 et l'Agent actifs en permanence, ordinateur éteint.",
    "Le token ne doit être utilisé que dans l'Agent officiel FullMetrix.",
  ],
  faq: [
    {
      q: "Qu'est-ce que l'Agent IA MT5 ?",
      a:
        "L'Agent IA MT5 est un programme à installer sur MetaTrader 5.\n\n" +
        "Il permet de relier ton compte de trading à FullMetrix afin de :\n" +
        "• synchroniser automatiquement tes données\n" +
        "• alimenter ton journal de trading\n" +
        "• analyser tes performances\n" +
        "• gérer certaines positions depuis FullMetrix\n" +
        "• utiliser les outils compatibles avec ton compte MT5",
    },
    {
      q: "Comment fonctionne concrètement l'Agent IA ?",
      a:
        "L'Agent crée une connexion entre ton compte MetaTrader 5 et la plateforme FullMetrix.\n\n" +
        "Pour permettre cette connexion, tu dois :\n" +
        "• autoriser le trading algorithmique dans MT5\n" +
        "• autoriser les requêtes WebRequest\n" +
        "• ajouter l'adresse https://ia.fullmargin.net dans les URL autorisées\n" +
        "• installer l'Agent sur un graphique MT5\n" +
        "• générer un token depuis FullMetrix\n" +
        "• ajouter ce token dans les paramètres de l'Agent\n\n" +
        "Le token permet d'identifier le compte connecté et de transmettre ses données vers FullMetrix.",
    },
    {
      q: "Que faut-il faire avant d'installer l'Agent ?",
      a:
        "Dans MetaTrader 5 :\n\n" +
        "1. Clique sur Outils.\n" +
        "2. Ouvre Options ou Paramètres.\n" +
        "3. Accède à la section Expert Advisors.\n" +
        "4. Active le trading algorithmique.\n" +
        "5. Active l'autorisation des WebRequest pour les URL listées.\n" +
        "6. Ajoute l'adresse suivante : https://ia.fullmargin.net\n" +
        "7. Valide les modifications.\n\n" +
        "Cette autorisation permet à MetaTrader 5 de communiquer avec FullMetrix.",
    },
    {
      q: "Comment installer l'Agent dans MetaTrader 5 ?",
      a:
        "1. Télécharge l'Agent depuis la section Agent IA de FullMetrix.\n" +
        "2. Ouvre MetaTrader 5.\n" +
        "3. Clique sur Fichier → Ouvrir le dossier des données.\n" +
        "4. Ouvre le dossier MQL5.\n" +
        "5. Place le fichier de l'Agent dans le dossier indiqué dans le guide d'installation.\n" +
        "6. Redémarre MetaTrader 5 ou actualise le navigateur.\n" +
        "7. Ouvre un graphique.\n" +
        "8. Ajoute l'Agent sur ce graphique.\n" +
        "9. Vérifie que le trading algorithmique est activé.",
    },
    {
      q: "Comment générer et utiliser un token ?",
      a:
        "Depuis la section Agent IA de FullMetrix :\n\n" +
        "1. Clique sur l'option permettant de générer un nouveau token.\n" +
        "2. Donne un nom au token pour reconnaître facilement le compte concerné.\n" +
        "3. Copie le token.\n" +
        "4. Retourne sur MetaTrader 5.\n" +
        "5. Ouvre les paramètres de l'Agent.\n" +
        "6. Colle le token dans le champ prévu.\n" +
        "7. Valide l'installation.\n\n" +
        "Le nom donné au token peut correspondre, par exemple, au broker, au numéro du compte ou à son utilisation :\n" +
        "• Compte principal\n" +
        "• Compte prop firm\n" +
        "• Compte Forex\n" +
        "• Compte Indices\n" +
        "• Compte Démo",
    },
    {
      q: "Peut-on connecter plusieurs comptes MT5 ?",
      a:
        "Oui.\n\n" +
        "Tu peux installer l'Agent sur plusieurs comptes MetaTrader 5.\n\n" +
        "Pour distinguer correctement leurs données, il est recommandé de générer un token différent pour chaque compte.\n\n" +
        "Tu pourras ainsi :\n" +
        "• consulter les performances de chaque compte séparément\n" +
        "• sélectionner un compte précis dans le journal\n" +
        "• gérer chaque compte individuellement\n" +
        "• éviter de mélanger les statistiques",
    },
    {
      q: "Que se passe-t-il si j'utilise le même token sur plusieurs comptes ?",
      a:
        "Si tu utilises le même token sur plusieurs comptes MT5, les données de ces comptes peuvent être regroupées dans FullMetrix.\n\n" +
        "Cela peut être utile si tu souhaites obtenir une vue globale de tous tes comptes.\n\n" +
        "Cependant, cela peut également créer de la confusion lorsque tu veux :\n" +
        "• analyser un seul compte\n" +
        "• identifier l'origine d'un trade\n" +
        "• comparer les performances\n" +
        "• interagir avec un compte précis\n\n" +
        "Pour une gestion plus claire, utilise un token différent pour chaque compte.",
    },
    {
      q: "Faut-il réinstaller l'Agent à chaque ouverture de MT5 ?",
      a:
        "Non.\n\n" +
        "L'installation de l'Agent se fait normalement une seule fois.\n\n" +
        "Une fois l'Agent installé et configuré :\n" +
        "• il reste disponible dans MetaTrader 5\n" +
        "• tu n'as pas besoin de recommencer toute l'installation\n" +
        "• il se reconnecte lorsque tu ouvres MT5, si les paramètres sont toujours actifs\n\n" +
        "Une nouvelle installation peut être nécessaire si :\n" +
        "• MetaTrader 5 a été complètement désinstallé\n" +
        "• le fichier de l'Agent a été supprimé\n" +
        "• l'Agent a été retiré ou mal configuré\n" +
        "• une mise à jour importante impose de remplacer le fichier",
    },
    {
      q: "MetaTrader 5 doit-il rester ouvert ?",
      a:
        "Oui.\n\n" +
        "Pour que l'Agent reste connecté en temps réel, MetaTrader 5 doit rester :\n" +
        "• ouvert\n" +
        "• connecté à Internet\n" +
        "• connecté au compte de trading\n" +
        "• avec l'Agent actif sur le graphique\n\n" +
        "Si MT5 est fermé, la synchronisation en temps réel et les actions à distance ne pourront plus fonctionner.",
    },
    {
      q: "Peut-on utiliser un VPS ?",
      a:
        "Oui.\n\n" +
        "Un VPS permet de laisser MetaTrader 5 et l'Agent actifs en permanence, même lorsque ton ordinateur est éteint.\n\n" +
        "Cela est particulièrement utile pour :\n" +
        "• la synchronisation continue\n" +
        "• le Copy Trading\n" +
        "• la gestion de plusieurs comptes\n" +
        "• l'exécution d'actions à distance\n" +
        "• éviter les interruptions de connexion",
    },
    {
      q: "Comment savoir si l'Agent est bien connecté ?",
      a:
        "Vérifie les éléments suivants :\n" +
        "• l'Agent est bien présent sur un graphique MT5\n" +
        "• le trading algorithmique est activé\n" +
        "• l'adresse https://ia.fullmargin.net est toujours autorisée\n" +
        "• le token est correctement renseigné\n" +
        "• le compte MT5 est connecté\n" +
        "• l'état de l'Agent apparaît comme actif ou connecté sur FullMetrix\n" +
        "• les données du compte commencent à apparaître dans le journal",
    },
    {
      q: "Que faire si l'installation ne fonctionne pas ?",
      a:
        "Vérifie en priorité :\n\n" +
        "1. Le trading algorithmique\n" +
        "Assure-toi qu'il est bien activé dans MetaTrader 5.\n\n" +
        "2. Le WebRequest\n" +
        "Vérifie que l'option est activée et que cette adresse est toujours présente : https://ia.fullmargin.net\n\n" +
        "3. Le token\n" +
        "Vérifie que :\n" +
        "• le token a bien été généré\n" +
        "• il est correctement copié dans l'Agent\n" +
        "• aucun caractère n'a été supprimé\n" +
        "• le token correspond au compte que tu souhaites connecter\n\n" +
        "4. Le graphique\n" +
        "Vérifie que l'Agent est toujours présent sur un graphique ouvert.\n\n" +
        "5. La connexion\n" +
        "Vérifie que MetaTrader 5 et ton compte de trading sont bien connectés à Internet.",
    },
    {
      q: "Pourquoi l'Agent peut-il apparaître hors ligne ?",
      a:
        "Les causes les plus fréquentes sont :\n" +
        "• MetaTrader 5 est fermé\n" +
        "• l'ordinateur ou le VPS est éteint\n" +
        "• la connexion Internet est interrompue\n" +
        "• le compte MT5 est déconnecté\n" +
        "• l'Agent a été retiré du graphique\n" +
        "• le trading algorithmique est désactivé\n" +
        "• l'adresse WebRequest a été supprimée\n" +
        "• le token est absent ou incorrect",
    },
    {
      q: "Que faire si les trades ne se synchronisent pas ?",
      a:
        "Vérifie :\n" +
        "• que MT5 est ouvert\n" +
        "• que l'Agent est actif\n" +
        "• que le token est toujours présent\n" +
        "• que le trading algorithmique est activé\n" +
        "• que https://ia.fullmargin.net est autorisé\n" +
        "• que le compte de trading est connecté\n" +
        "• qu'aucun message d'erreur n'apparaît dans MT5\n\n" +
        "Si le problème persiste, contacte le support avec :\n" +
        "• l'adresse e-mail de ton compte FullMargin\n" +
        "• le nom ou le numéro du compte concerné\n" +
        "• le nom du token utilisé\n" +
        "• une capture de l'Agent sur MT5\n" +
        "• une capture de l'état de connexion dans FullMetrix\n" +
        "• le message d'erreur éventuel",
    },
    {
      q: "L'Agent peut-il prendre des positions automatiquement ?",
      a:
        "Non.\n\n" +
        "L'Agent n'est pas un robot de trading autonome et ne décide pas seul d'ouvrir des positions.\n\n" +
        "Il sert à connecter MT5 à FullMetrix et à exécuter les actions demandées depuis les outils compatibles.",
    },
    {
      q: "L'Agent peut-il gérer mes positions ?",
      a:
        "Oui, lorsque tu utilises une fonctionnalité prévue à cet effet, comme la section Exécution ou le Copy Trading.\n\n" +
        "Selon l'action demandée, l'Agent peut notamment :\n" +
        "• ouvrir une position\n" +
        "• fermer une position\n" +
        "• modifier un Stop Loss\n" +
        "• modifier un Take Profit\n" +
        "• placer un ordre en attente\n" +
        "• annuler ou modifier un ordre",
    },
    {
      q: "Mes identifiants MT5 sont-ils nécessaires ?",
      a:
        "Tu ne dois jamais partager publiquement :\n" +
        "• ton mot de passe principal MT5\n" +
        "• ton mot de passe investisseur\n" +
        "• tes identifiants FullMargin\n" +
        "• tes tokens\n" +
        "• les informations privées de tes comptes\n\n" +
        "Le token doit uniquement être utilisé dans l'Agent officiel FullMetrix.",
    },
    {
      q: "L'Agent fonctionne-t-il sur MT4, cTrader ou d'autres plateformes ?",
      a:
        "Actuellement, l'Agent FullMetrix fonctionne uniquement sur MetaTrader 5.\n\n" +
        "Il n'est pas encore compatible avec :\n" +
        "• MetaTrader 4\n" +
        "• cTrader\n" +
        "• TradingView\n" +
        "• d'autres plateformes de trading\n\n" +
        "Une version compatible avec cTrader est envisagée dans les prochaines mises à jour.",
    },
    {
      q: "Comment désinstaller l'Agent ?",
      a:
        "Pour arrêter temporairement l'Agent :\n" +
        "• retire-le du graphique MT5\n" +
        "• ou ferme MetaTrader 5\n\n" +
        "Pour le supprimer complètement :\n" +
        "• retire l'Agent du graphique\n" +
        "• ouvre le dossier des données de MT5\n" +
        "• supprime le fichier de l'Agent\n" +
        "• redémarre ou actualise MetaTrader 5\n" +
        "• supprime ou désactive le token dans FullMetrix si nécessaire",
    },
    {
      q: "Comment contacter le support ?",
      a:
        "Pour obtenir une réponse plus rapide, nous recommandons de contacter directement le support FullMargin par WhatsApp.\n\n" +
        "Le support par e-mail reste disponible, mais le délai de réponse peut être plus long.\n\n" +
        "Lors de ta demande, ajoute :\n" +
        "• l'adresse e-mail de ton compte FullMargin\n" +
        "• le compte MT5 concerné\n" +
        "• le nom du token\n" +
        "• une description précise du problème\n" +
        "• des captures d'écran\n" +
        "• le message d'erreur éventuel",
    },
  ],
  related: ["journal-auto", "execution", "copy-trading"],
};

export const en = {
  title: "MT5 AI Agent",
  tagline: "Connect your MetaTrader 5 account to FullMetrix",
  readMin: 8,
  intro:
    "The MT5 AI Agent is a program you install on MetaTrader 5. It links your trading account to FullMetrix so it can sync your data automatically, feed your trading journal, analyse your performance, manage some positions from FullMetrix and enable the tools compatible with your MT5 account.",
  brief: [
    "Allow algorithmic trading and WebRequest in MetaTrader 5",
    "Install the Agent on an MT5 chart",
    "Generate a FullMetrix token and paste it into the Agent",
  ],
  steps: [
    {
      title: "Allow the connection in MetaTrader 5",
      text: "Tools → Options (or Settings) → Expert Advisors: enable algorithmic trading, enable WebRequest for listed URLs, add https://ia.fullmargin.net then confirm.",
    },
    { title: "Download the Agent", text: "From the AI Agent section of FullMetrix." },
    {
      title: "Copy the file into MT5",
      text: "MetaTrader 5 → File → Open Data Folder → MQL5 folder, then place the Agent file in the folder shown in the installation guide.",
    },
    { title: "Restart MetaTrader 5", text: "Restart MT5 or refresh the Navigator so it picks up the Agent." },
    {
      title: "Add the Agent to a chart",
      text: "Open a chart, drop the Agent onto it, and check that algorithmic trading is enabled.",
    },
    {
      title: "Generate a token and paste it",
      text: "In the FullMetrix AI Agent section: generate a token, give it a recognisable name, copy it, then paste it into the Agent inputs on MT5 and confirm.",
    },
  ],
  tips: [
    "One token per MT5 account: that is what keeps statistics separate and readable.",
    "Name your tokens (Main account, Prop firm account, Forex account, Indices account, Demo account) to find your way around.",
    "MetaTrader 5 must stay open and connected: no running terminal, no real-time sync.",
    "A VPS keeps MT5 and the Agent running permanently, even with your computer off.",
    "The token must only be used in the official FullMetrix Agent.",
  ],
  faq: [
    {
      q: "What is the MT5 AI Agent?",
      a:
        "The MT5 AI Agent is a program you install on MetaTrader 5.\n\n" +
        "It links your trading account to FullMetrix in order to:\n" +
        "• sync your data automatically\n" +
        "• feed your trading journal\n" +
        "• analyse your performance\n" +
        "• manage some positions from FullMetrix\n" +
        "• use the tools compatible with your MT5 account",
    },
    {
      q: "How does the AI Agent actually work?",
      a:
        "The Agent creates a connection between your MetaTrader 5 account and the FullMetrix platform.\n\n" +
        "To allow that connection you must:\n" +
        "• enable algorithmic trading in MT5\n" +
        "• allow WebRequest calls\n" +
        "• add https://ia.fullmargin.net to the allowed URLs\n" +
        "• install the Agent on an MT5 chart\n" +
        "• generate a token from FullMetrix\n" +
        "• add that token to the Agent inputs\n\n" +
        "The token identifies the connected account and lets its data flow to FullMetrix.",
    },
    {
      q: "What must be done before installing the Agent?",
      a:
        "In MetaTrader 5:\n\n" +
        "1. Click Tools.\n" +
        "2. Open Options or Settings.\n" +
        "3. Go to the Expert Advisors section.\n" +
        "4. Enable algorithmic trading.\n" +
        "5. Enable WebRequest for listed URLs.\n" +
        "6. Add this address: https://ia.fullmargin.net\n" +
        "7. Confirm the changes.\n\n" +
        "This permission lets MetaTrader 5 communicate with FullMetrix.",
    },
    {
      q: "How do I install the Agent in MetaTrader 5?",
      a:
        "1. Download the Agent from the AI Agent section of FullMetrix.\n" +
        "2. Open MetaTrader 5.\n" +
        "3. Click File → Open Data Folder.\n" +
        "4. Open the MQL5 folder.\n" +
        "5. Place the Agent file in the folder shown in the installation guide.\n" +
        "6. Restart MetaTrader 5 or refresh the Navigator.\n" +
        "7. Open a chart.\n" +
        "8. Add the Agent to that chart.\n" +
        "9. Check that algorithmic trading is enabled.",
    },
    {
      q: "How do I generate and use a token?",
      a:
        "From the AI Agent section of FullMetrix:\n\n" +
        "1. Click the option to generate a new token.\n" +
        "2. Name the token so you recognise the account it belongs to.\n" +
        "3. Copy the token.\n" +
        "4. Go back to MetaTrader 5.\n" +
        "5. Open the Agent inputs.\n" +
        "6. Paste the token in the dedicated field.\n" +
        "7. Confirm the installation.\n\n" +
        "The token name can match, for example, the broker, the account number or its use:\n" +
        "• Main account\n" +
        "• Prop firm account\n" +
        "• Forex account\n" +
        "• Indices account\n" +
        "• Demo account",
    },
    {
      q: "Can I connect several MT5 accounts?",
      a:
        "Yes.\n\n" +
        "You can install the Agent on several MetaTrader 5 accounts.\n\n" +
        "To keep their data apart, generate a different token for each account.\n\n" +
        "You will then be able to:\n" +
        "• review the performance of each account separately\n" +
        "• select a specific account in the journal\n" +
        "• manage each account individually\n" +
        "• avoid mixing statistics",
    },
    {
      q: "What happens if I use the same token on several accounts?",
      a:
        "If you use the same token on several MT5 accounts, their data can be grouped together in FullMetrix.\n\n" +
        "That can be useful for an overall view of all your accounts.\n\n" +
        "But it can also create confusion when you want to:\n" +
        "• analyse a single account\n" +
        "• identify where a trade came from\n" +
        "• compare performance\n" +
        "• interact with a specific account\n\n" +
        "For clearer management, use a different token per account.",
    },
    {
      q: "Do I have to reinstall the Agent every time I open MT5?",
      a:
        "No.\n\n" +
        "The Agent is normally installed once.\n\n" +
        "Once installed and configured:\n" +
        "• it stays available in MetaTrader 5\n" +
        "• you do not need to redo the whole installation\n" +
        "• it reconnects when you open MT5, if the settings are still active\n\n" +
        "A new installation may be needed if:\n" +
        "• MetaTrader 5 was fully uninstalled\n" +
        "• the Agent file was deleted\n" +
        "• the Agent was removed or misconfigured\n" +
        "• a major update requires replacing the file",
    },
    {
      q: "Does MetaTrader 5 have to stay open?",
      a:
        "Yes.\n\n" +
        "For the Agent to stay connected in real time, MetaTrader 5 must stay:\n" +
        "• open\n" +
        "• connected to the internet\n" +
        "• logged into the trading account\n" +
        "• with the Agent active on the chart\n\n" +
        "If MT5 is closed, real-time sync and remote actions stop working.",
    },
    {
      q: "Can I use a VPS?",
      a:
        "Yes.\n\n" +
        "A VPS keeps MetaTrader 5 and the Agent running permanently, even when your computer is off.\n\n" +
        "This is especially useful for:\n" +
        "• continuous sync\n" +
        "• Copy Trading\n" +
        "• managing several accounts\n" +
        "• executing remote actions\n" +
        "• avoiding connection drops",
    },
    {
      q: "How do I know the Agent is properly connected?",
      a:
        "Check the following:\n" +
        "• the Agent is present on an MT5 chart\n" +
        "• algorithmic trading is enabled\n" +
        "• https://ia.fullmargin.net is still allowed\n" +
        "• the token is correctly filled in\n" +
        "• the MT5 account is connected\n" +
        "• the Agent shows as active or connected in FullMetrix\n" +
        "• account data starts appearing in the journal",
    },
    {
      q: "What if the installation does not work?",
      a:
        "Check first:\n\n" +
        "1. Algorithmic trading\n" +
        "Make sure it is enabled in MetaTrader 5.\n\n" +
        "2. WebRequest\n" +
        "Check the option is on and this address is still listed: https://ia.fullmargin.net\n\n" +
        "3. The token\n" +
        "Check that:\n" +
        "• the token was generated\n" +
        "• it is correctly pasted into the Agent\n" +
        "• no character was removed\n" +
        "• the token matches the account you want to connect\n\n" +
        "4. The chart\n" +
        "Check the Agent is still on an open chart.\n\n" +
        "5. The connection\n" +
        "Check MetaTrader 5 and your trading account are connected to the internet.",
    },
    {
      q: "Why can the Agent show as offline?",
      a:
        "The most frequent causes are:\n" +
        "• MetaTrader 5 is closed\n" +
        "• the computer or VPS is off\n" +
        "• the internet connection dropped\n" +
        "• the MT5 account is disconnected\n" +
        "• the Agent was removed from the chart\n" +
        "• algorithmic trading is disabled\n" +
        "• the WebRequest address was removed\n" +
        "• the token is missing or incorrect",
    },
    {
      q: "What if trades do not sync?",
      a:
        "Check:\n" +
        "• that MT5 is open\n" +
        "• that the Agent is active\n" +
        "• that the token is still filled in\n" +
        "• that algorithmic trading is enabled\n" +
        "• that https://ia.fullmargin.net is allowed\n" +
        "• that the trading account is connected\n" +
        "• that no error message shows in MT5\n\n" +
        "If the problem persists, contact support with:\n" +
        "• the email address of your FullMargin account\n" +
        "• the name or number of the account involved\n" +
        "• the name of the token used\n" +
        "• a screenshot of the Agent on MT5\n" +
        "• a screenshot of the connection state in FullMetrix\n" +
        "• the error message, if any",
    },
    {
      q: "Can the Agent open positions on its own?",
      a:
        "No.\n\n" +
        "The Agent is not an autonomous trading robot and never decides to open positions by itself.\n\n" +
        "It connects MT5 to FullMetrix and executes the actions requested from the compatible tools.",
    },
    {
      q: "Can the Agent manage my positions?",
      a:
        "Yes, when you use a feature designed for it, such as the Execution section or Copy Trading.\n\n" +
        "Depending on the requested action, the Agent can:\n" +
        "• open a position\n" +
        "• close a position\n" +
        "• modify a Stop Loss\n" +
        "• modify a Take Profit\n" +
        "• place a pending order\n" +
        "• cancel or modify an order",
    },
    {
      q: "Are my MT5 credentials needed?",
      a:
        "You must never share publicly:\n" +
        "• your MT5 master password\n" +
        "• your investor password\n" +
        "• your FullMargin credentials\n" +
        "• your tokens\n" +
        "• the private information of your accounts\n\n" +
        "The token must only be used in the official FullMetrix Agent.",
    },
    {
      q: "Does the Agent work on MT4, cTrader or other platforms?",
      a:
        "Right now the FullMetrix Agent only works on MetaTrader 5.\n\n" +
        "It is not yet compatible with:\n" +
        "• MetaTrader 4\n" +
        "• cTrader\n" +
        "• TradingView\n" +
        "• other trading platforms\n\n" +
        "A cTrader-compatible version is considered for upcoming updates.",
    },
    {
      q: "How do I uninstall the Agent?",
      a:
        "To stop the Agent temporarily:\n" +
        "• remove it from the MT5 chart\n" +
        "• or close MetaTrader 5\n\n" +
        "To remove it completely:\n" +
        "• remove the Agent from the chart\n" +
        "• open the MT5 data folder\n" +
        "• delete the Agent file\n" +
        "• restart or refresh MetaTrader 5\n" +
        "• delete or disable the token in FullMetrix if needed",
    },
    {
      q: "How do I contact support?",
      a:
        "For a faster answer, we recommend contacting FullMargin support directly on WhatsApp.\n\n" +
        "Email support is still available, but the response time can be longer.\n\n" +
        "With your request, include:\n" +
        "• the email address of your FullMargin account\n" +
        "• the MT5 account involved\n" +
        "• the token name\n" +
        "• a precise description of the problem\n" +
        "• screenshots\n" +
        "• the error message, if any",
    },
  ],
  related: ["journal-auto", "execution", "copy-trading"],
};
